import { Experiment, Layer } from '@statsig/react-bindings';

type GetAssignedVariantArgs = { source: Experiment | Layer; statsigKey: string; variant: string };

// Only a layer evaluation carries the experiment it allocated the user to
const LAYER_EVALUATION_FIELD = 'allocated_experiment_name';

const getAssignedVariant = ({ source, statsigKey, variant }: GetAssignedVariantArgs) => {
    const evaluation = source.__evaluation;
    const isExperimentRunning = Boolean(evaluation?.is_experiment_active);
    const isUserInExperiment = Boolean(evaluation?.is_user_in_experiment);
    const isLayer = Boolean(evaluation && LAYER_EVALUATION_FIELD in evaluation);
    const isKeyOfSiblingExperiment = isLayer && !evaluation?.explicit_parameters?.includes(statsigKey);
    const isUnassigned = isExperimentRunning && (!isUserInExperiment || isKeyOfSiblingExperiment);

    if (isUnassigned) {
        return '';
    }

    return variant;
};

export default getAssignedVariant;
